import { render, staticRenderFns } from "./PlusArticle.vue?vue&type=template&id=8b44968c&scoped=true"
import script from "./PlusArticle.vue?vue&type=script&lang=js"
export * from "./PlusArticle.vue?vue&type=script&lang=js"
import style0 from "./PlusArticle.vue?vue&type=style&index=0&id=8b44968c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b44968c",
  null
  
)

export default component.exports